import React, { useState, useEffect, Fragment } from "react";
import { useDispatch } from "react-redux";
import { useForm, Controller } from "react-hook-form";
import Dialog from "../../../atoms/dialog";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Grid from "@material-ui/core/Grid";
import CircularProgress from "@material-ui/core/CircularProgress";
import { getConfigarationList } from "../../../../store/profile/actions";
import RsliceSelector from "./RsliceSelector";
import { invokeGetService, invokePostService, toggleValidator } from '../../../../store/global/actions';
import LoaderWithProgress from "../../../atoms/loader/LoaderWithProgress";


const DeploySelectorPopUp = (props) => {
    const { onClose, onDeployBlueprint, setBlueprintValidatorOpen, setDeployConfig, validationsList, setValidationsList, fetchValidations, setDeploymentData } = props
    const dispatch = useDispatch();


    const [loading, setLoading] = useState(false);
    const [options, setOptions] = useState({ loading: true, data: [] });
    const [savedConfig, setSavedConfig] = useState(null);

    const { trigger, register, setValue, control, reset, errors, getValues, handleSubmit } = useForm();


    useEffect(() => {

        fetchValidations();

        getConfigarationList().then((data) => {
            setOptions({ loading: false, configurations: data, data: data.map(({ _id, configuration_name = "" }) => ({ value: _id, label: configuration_name || "" })) });
        });

        getLastSavedConfig();

    }, []);

    


    const getLastSavedConfig = async () => {
        setLoading(true)
        dispatch(invokeGetService('getSavedDeployCommands', [])).then((response) => {
            const data = response.data
            setSavedConfig({
                configurationId: data.deployment_id,
                sslice: data.sslice?.trim(),
                rslice: data.rslice?.trim()
            })
            setLoading(false)
        }).catch((error) => {
            setLoading(false)
            console.log(error)
        })
    }




    const onSubmit = () => {
        const blueprintValidationFlag = localStorage.getItem("disableBlueprintValidation");
        const {configurationId, rslice, sslice} = getValues();


        trigger().then((result) => {
            if (!result) return;
            if(validationsList?.length > 0){
                setDeploymentData({
                    ...getValues(),
                    rslice: rslice.trim(),
                    sslice: sslice.trim()
                })
                onClose({ disableIcon: true });
                // setBlueprintValidatorOpen(true);
                dispatch(toggleValidator(true))
                return;
            }else{
                onDeployBlueprint({
                    ...getValues(),
                    rslice: rslice.trim(),
                    sslice: sslice.trim()
                });
            }
            
        });

    };

   
    return (
        <>
            <Dialog
                title="Select deployment configuration"
                open={true}
                handleClose={(event, reason) => {
                    if(reason && reason === 'backdropClick') return false
                    onClose({ disableIcon: false })
                }}
                container_id={"deployment_selector"} 
                actions={
                    <Grid container style={{ padding: "0px 6px" }}>
                        
                        <Grid item xs={12} style={{ display: "flex", justifyContent: "flex-end" }}>
                            <Button
                                disabled={loading}
                                onClick={handleSubmit(onSubmit)}
                                color="primary"
                                startIcon={loading ? <CircularProgress color="secondary" size={20} /> : <Fragment />}
                                variant="contained"
                                style={{ marginLeft: 10, textTransform: 'capitalize' }}
                            >
                                Save and Deploy
                            </Button>
                        </Grid>
                    </Grid>
                }
            >
                {
                    loading ?
                        <LoaderWithProgress isContent />
                        :
                        (
                            <Grid container direction={"row"} spacing={1}>
                                <Controller
                                    control={control}
                                    rules={{ required: true }}
                                    name="configurationId"
                                    defaultValue=""
                                    render={({ onChange, onBlur, value, name, ref }) => {
                                        return (
                                            <Grid item xs={12}>
                                                <TextField
                                                    select
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    fullWidth
                                                    label="Configuration"
                                                    required
                                                    disabled={options.loading}
                                                    ref={ref}
                                                    placeholder="Select"
                                                    onChange={(e) => onChange(e.target.value)}
                                                    onBlur={onBlur}
                                                    name={name}
                                                    value={value}
                                                    error={Boolean(errors.configurationId && errors.configurationId)}
                                                    SelectProps={{
                                                        native: true,
                                                    }}
                                                    variant="outlined"
                                                >
                                                    <option key={"empty"} value={""}>
                                                        Choose
                                                    </option>

                                                    {(options.data || []).map((option) => (
                                                        <option id={option.value} key={option.value} value={option.value}>
                                                            {option.label}
                                                        </option>
                                                    ))}
                                                </TextField>
                                            </Grid>
                                        );
                                    }}
                                />
                                <RsliceSelector register={register} savedConfig={savedConfig} errors={errors} getValues={getValues} reset={reset} control={control} configurations={(options && options.configurations) || []} />
                            </Grid>
                        )
                }
            </Dialog>
        </>
    );
};

export default DeploySelectorPopUp